export default "__VITE_ASSET__3e96b639__"